export default [
    {
        role: "External Reviewer",
        item: "International Conference on Program Comprehension",
        venue: "ICPC",
        year: 2019
    },
    {
        role: "External Reviewer",
        item: "International Conference on Software Engineering - Poster Track",
        venue: 'ICSE',
        year: 2019
    },
    
    {
        role: "External Reviewer",
        item: "International Conference on Software Engineering - Tool Track",
        venue: "ICSE",
        year: 2019
    },
    {
        role: "External Reviewer",
        item: "International Working Conference on Source Code Analysis and Manipulation",
        venue: "SCAM",
        year: 2019
    }
]